// extracted by mini-css-extract-plugin
export default {"wrapper":"iB5ErCi"};